module.exports=require('./lib/picker.vue')


//////////////////
// WEBPACK FOOTER
// ./~/_vue-pickers@1.1.5@vue-pickers/index.js
// module id = 253
// module chunks = 106